var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDdayEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.00195312,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFDB45"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0291 17.998H6.57558C6.42293 17.998 6.27653 17.9374 6.16858 17.8295C6.06064 17.7215 6 17.5751 6 17.4225V14.2074C6 14.1318 6.01489 14.0569 6.04381 13.9871C6.07274 13.9173 6.11514 13.8538 6.16858 13.8004L14.8023 5.16663C14.9103 5.05869 15.0567 4.99805 15.2093 4.99805C15.362 4.99805 15.5084 5.05869 15.6163 5.16663L18.8314 8.38172C18.9394 8.48966 19 8.63606 19 8.78871C19 8.94137 18.9394 9.08777 18.8314 9.19571L10.0291 17.998Z",
    stroke: "#FFEEB1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9072 7.06152L16.9363 11.0906",
    stroke: "#FFEEB1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6628 17.9983H10.0291L6.03662 14.0059",
    stroke: "#FFEEB1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdayEditIcon);
export default __webpack_public_path__ + "static/media/dday_edit_icon.a76d042320ba549224d94a33f0c6d873.svg";
export { ForwardRef as ReactComponent };